import ResponseSuccessInterceptor from "./response_success_interceptor";
import ResponseFailureInterceptor from "./response_failure_interceptor";
import RequestSuccessInterceptor from "./request_success_interceptor";
import RequestFailureInterceptor from "./request_failure_interceptor";
import { axios, base } from "react-netjoy";
import Config from '../../config';

let instance: Network

class Network {

    netClient: base.ServiceClientInterface

    static get instance() {
        if (!instance) {
            instance = new Network()
        }
        return instance
    }

    constructor() {
        const responseInterceptor = new axios.AxiosResponseInterceptorList<{}>()
        const requestInterceptor = new axios.AxiosRequestInterceptorList<{}>()
        responseInterceptor.addInterceptor(ResponseSuccessInterceptor, ResponseFailureInterceptor);
        requestInterceptor.addInterceptor(RequestSuccessInterceptor, RequestFailureInterceptor);
        console.log('Config.API_URL', Config.API_URL)
        this.netClient = axios.getAxiosNewClient(Config.API_URL,{
            // baseHeaders: {"Access-Control-Allow-Origin": "*"},
            requestInterceptorList: requestInterceptor.getList(),
            responseInterceptorList: responseInterceptor.getList(),
            debugPrint: false,
            timeoutMillis: 60000
        })
    }
}

export default Network
